import apiClient from '../../api/http-common';

const getMessagingOptionsData = () => apiClient.post('/settings/messaging/get-options-data');

const getMessagingEdit = () => apiClient.post('/settings/messaging/edit');

const getMessagingUpdate = (data) => apiClient.post('/settings/messaging/update', data);

const MessagingService = {
  getMessagingOptionsData,
  getMessagingEdit,
  getMessagingUpdate
};

export default MessagingService;
